/*!

=========================================================
* Argon Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library to set properties for componentsß
import PropTypes from "prop-types";
// reactstrap components
import { Container, Row, Col } from "reactstrap";

class EventsHeader extends React.Component {
  render() {
    return (
      <>
        <div className="header py-4 py-lg-8 pt-lg-9" style={{backgroundColor: "#c61308"}}>
          <Container>
            <div className="header-body text-center mb-4">
              <Row className="justify-content-center">
                <Col className="px-5" lg="6" md="8" xl="5">
                  {this.props.title ? (
                    <h1 className="text-white">{this.props.title}</h1>
                  ) : null}
                </Col>
              </Row>
            </div>
          </Container>
          <div className="separator separator-bottom separator-skew zindex-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                style={{fill: "#f8f9fe"}}
                points="2560 0 2560 100 0 100"
              />
            </svg>
          </div>
        </div>
      </>
    );
  }
}

EventsHeader.propTypes = {
  title: PropTypes.string,
  lead: PropTypes.string
};

export default EventsHeader;
